import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { AgTextFloatingFilterComponent } from '../../../../global/gx-ag-grid/ag-text-floating-filter/ag-text-floating-filter.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { CustomFloatingFilterViewModel } from '../../../../global/gx-ag-grid/ag-floating-filter.component';
import { combineLatestWith, Observable } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { GxInputDirective } from '../../../../../directives/gxinput.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { LetDirective } from '@ngrx/component';
import { MatMenu, MatMenuContent, MatMenuTrigger } from '@angular/material/menu';
import { RecentUpdateFilterComponent } from './recent-update-filter/recent-update-filter.component';
import { RecentUpdateFilterLocalStoreService } from './recent-update-filter-local-store.service';

interface RecentUpdateFloatingFilterViewModel extends CustomFloatingFilterViewModel {
  loading: boolean;
  backgroundClassName?: string;
}

@Component({
    selector: 'app-recent-update-floating-filter',
    templateUrl: './recent-update-floating-filter.component.html',
    styleUrls: ['../../../../global/gx-ag-grid/ag-text-floating-filter/ag-text-floating-filter.component.scss',
                './recent-update-floating-filter.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [RecentUpdateFilterLocalStoreService],
    imports: [
      LetDirective,
      MatFormField,
      MatInput,
      FormsModule,
      GxInputDirective,
      ReactiveFormsModule,
      MatIconButton,
      MatSuffix,
      MatIcon,
      MatTooltip,
      MatProgressSpinner,
      TranslateModule,
      MatMenu,
      MatMenuTrigger,
      MatMenuContent,
      RecentUpdateFilterComponent,
    ],
})
export class RecentUpdateFloatingFilterComponent extends AgTextFloatingFilterComponent {

  @ViewChild('filterMenuTrigger', { read: MatMenuTrigger }) filterMenuTrigger: MatMenuTrigger;

  protected readonly loading$ = this.localStore.loading$;

  public override viewModel$: Observable<RecentUpdateFloatingFilterViewModel> = this._viewModel$
      .asObservable()
      .pipe(
          combineLatestWith(this.loading$),
          map(([viewModel, loading]) => {
            return {
              ...viewModel,
              loading,
              backgroundClassName: this.getBackgroundClassName(viewModel.filterModel)
            };
          })
      );

  constructor(private translate: TranslateService,
              private localStore: RecentUpdateFilterLocalStoreService) {
    super();
  }

  /**
   * Get tooltip for the 'get locations with updates' button
   */
  protected getLocationsWithUpdatesTooltip() {
    return this.translate.instant(
        'FILTER_LOCATIONS_BY_UPDATED_FIELD.TOOLTIP',
        {field: this.params.filterParams.colDef.headerName})
  }

  /**
   * Close the filter menu programmatically
   * @protected
   */
  protected closeFilterMenu() {
    this.filterMenuTrigger?.closeMenu();
  }

}
